/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Checkbox,
  Loader,
  Modal,
  Button,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import cx from 'classnames';
import api from '../../api';
import CreateJiraIssueSettingModal from '../Jira/CreateJiraIssueSettingModal';
import { convertPropertiesToCamelCase } from '../../utils/shared';
import WithRouter from '../Extensions/WithRouter';
import JiraLogo from '../../images/icons/jira/jira_origin.svg';

class IssueSetting extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.state = {
      isLoading: false,
      isUseIssue: false,
      isOpenModal: false,
      isOpenAlert: false,
      isOpenMCI: false,
      hasJira: false,
      defaultSettings: {},
      securities: [],
      licenses: [],
      litigators: [],
    };
    this.handleIssueToggle = this.handleIssueToggle.bind(this);
    this.handleSecurityCheckChange = this.handleSecurityCheckChange.bind(this);
    this.handleLicenseCheckChange = this.handleLicenseCheckChange.bind(this);
    this.handleLitigatorCheckChange = this.handleLitigatorCheckChange.bind(this);
    this.handleSaveModal = this.handleSaveModal.bind(this);
    this.handleRevert = this.handleRevert.bind(this);
    this.handleMCIOpen = this.handleMCIOpen.bind(this);
    this.handleJiraIssueCallback = this.handleJiraIssueCallback.bind(this);
    this.setIssueSetting = this.setIssueSetting.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.getIssueSetting();
  }

  handleIssueToggle(e) {
    const { t } = this.props;
    const { isUseIssue, defaultSettings } = this.state;
    const { isAdmin } = this.props.state.user;

    if (!isAdmin) {
      return;
    }

    if (e.target.text === t('system.button.on')) {
      if (isUseIssue) {
        return;
      }
      return this.setState({
        isUseIssue: true,
        securities: defaultSettings.security,
        licenses: defaultSettings.license,
        litigators: defaultSettings.litigator,
      });
    }
    if (!isUseIssue) {
      return;
    }
    return this.setState({
      isUseIssue: false,
    });
  }

  handleSecurityCheckChange(e, { value }) {
    const { securities } = this.state;
    let newState;
    if (securities.indexOf(value) > -1) {
      newState = securities.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...securities, value];
    }
    this.setState({
      securities: newState,
    });
  }

  handleLicenseCheckChange(e, { value }) {
    const { licenses } = this.state;
    let newState;
    if (licenses.indexOf(value) > -1) {
      newState = licenses.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...licenses, value];
    }
    this.setState({
      licenses: newState,
    });
  }

  handleLitigatorCheckChange(e, { value }) {
    const { litigators } = this.state;
    let newState;
    if (litigators.indexOf(value) > -1) {
      newState = litigators.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...litigators, value];
    }
    this.setState({
      litigators: newState,
    });
  }

  handleSaveModal() {
    const { t } = this.props;
    this.modalAction = t('modal.title.attention');
    this.modalBody = t('settings.message.save_setting');
    this.setState({
      isOpenModal: true,
    });
  }

  handleRevert() {
    const { defaultSettings } = this.state;

    this.setState({
      securities: defaultSettings.security,
      licenses: defaultSettings.license,
      litigators: defaultSettings.litigator,
    });
  }

  handleMCIOpen() {
    const { t } = this.props;
    const { defaultSettings } = this.state;
    if (!defaultSettings.useIssue) {
      this.modalAction = t('modal.title.attention');
      this.modalBody = t('settings.message.issue_setting_error');

      return this.setState({
        isOpenAlert: true,
      });
    }
    this.setState({
      isOpenMCI: true,
    });
  }

  handleJiraIssueCallback() {
    this.setState({
      isOpenMCI: false,
    }, () => {
      this.getIssueSetting();
    });
  }

  getIssueSetting() {
    const { t } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getIssueSetting()
        .then((response) => {
          const data = convertPropertiesToCamelCase(response.response);
          this.setState({
            isLoading: false,
            defaultSettings: data,
            isUseIssue: data.useIssue,
            securities: data.security,
            licenses: data.license,
            litigators: data.litigator,
            hasJira: data.hasJira,
          });
        })
        .catch((err) => {
          console.log(err);
          this.modalAction = t('modal.title.attention');
          this.modalBody = t('settings.message.user_not_permitted');
          this.setState({
            isLoading: false,
            isOpenAlert: true,
          });
        });
    });
  }

  setIssueSetting() {
    const {
      isUseIssue, securities, licenses, litigators
    } = this.state;
    const { t } = this.props;
    const data = {
      use_issue: isUseIssue,
      security: securities,
      license: licenses,
      litigator: litigators,
    };

    this.setState({
      isOpenModal: false,
      isLoading: true,
    }, () => {
      api
        .setIssueSetting(data)
        .then((response) => {
          const res = convertPropertiesToCamelCase(response.response);

          this.setState({
            isLoading: false,
            defaultSettings: res,
          });
        })
        .catch((err) => {
          console.log(err);
          this.modalAction = t('modal.title.attention');
          this.modalBody = t('settings.message.user_not_permitted');
          this.setState({
            isLoading: false,
            isOpenAlert: true,
          });
        });
    });
  }

  closeModal() {
    this.setState({
      isOpenModal: false,
      isOpenAlert: false,
      isOpenMCI: false,
    });
  }

  render() {
    const {
      isLoading,
      isUseIssue,
      securities,
      licenses,
      litigators,
      hasJira,
      isOpenMCI,
    } = this.state;
    const { isAdmin } = this.props.state.user;
    const { t } = this.props;

    const renderIfReady = (element) => {
      return isLoading ? (
        <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
          {t('list.title.loading')}
        </Loader>
      ) : (
        element
      );
    };

    return (
      <div className="setting_issue_main" style={{ position: 'relative' }}>
        <div className="contents_header">
          <div className="contents_header_inner">
            <h3 className="content_title">{t('settings.list.issue_setting')}</h3>
          </div>
          <div className="button_wrap util_item">
            {
              hasJira ? (
                <Button
                  className="jira"
                  onClick={this.handleMCIOpen}
                  onKeyUp={this.handleMCIOpen}
                >
                  <span className="icon-wrap">
                    <img className="icon-jira" src={JiraLogo} alt="" />
                  </span>
                  {t('settings.list.edit_jira_settings')}
                </Button>
              ) : (
                <Button
                  className="jira"
                  onClick={this.handleMCIOpen}
                  onKeyUp={this.handleMCIOpen}
                >
                  <span className="icon-wrap">
                    <img className="icon-jira" src={JiraLogo} alt="" />
                  </span>
                  {t('settings.list.create_jira_settings')}
                </Button>
              )
            }
          </div>
        </div>
        {renderIfReady(
          <div className="setting_issues_content">
            <div className="setting_issues_content_item_wrap">
              <h3>
                {t('settings.list.iseeu_creation')}
              </h3>
              <div className="setting_issues_content_item">
                {
                  isAdmin ? (
                    <div className="switch">
                      <a
                        className={cx(
                          {
                            checked: isUseIssue,
                          }
                        )}
                        onClick={this.handleIssueToggle}
                        onKeyUp={this.handleIssueToggle}
                      >
                        {t('system.button.on')}
                      </a>
                      <a
                        className={cx(
                          {
                            checked: !isUseIssue,
                          }
                        )}
                        onClick={this.handleIssueToggle}
                        onKeyUp={this.handleIssueToggle}
                      >
                        {t('system.button.off')}
                      </a>
                    </div>
                  ) : (
                    <div className="switch">
                      <a
                        className={cx(
                          {
                            checked: isUseIssue,
                          },
                          'disable'
                        )}
                      >
                        {t('system.button.on')}
                      </a>
                      <a
                        className={cx(
                          {
                            checked: !isUseIssue,
                          },
                          'disable'
                        )}
                      >
                        {t('system.button.off')}
                      </a>
                    </div>
                  )
                }

                {
                  isUseIssue ? (
                    <p className="text">
                      {t('settings.message.use_issue')}
                    </p>
                  ) : (
                    <p className="text">
                      {t('settings.message.not_use_issue')}
                    </p>
                  )
                }
              </div>
            </div>
            {
              isUseIssue ? (
                <div className="setting_issues_content_item_wrap">
                  <h3>
                    {t('settings.list.issue_creation_scope')}
                  </h3>
                  <div className="setting_issues_content_item">
                    <span className="label">
                      {t('project.menu.security')}
                    </span>
                    <ul className="options">
                      <li>
                        <Checkbox
                          label={t('project.menu.critical')}
                          value="critical"
                          checked={securities.indexOf('critical') > -1}
                          onChange={this.handleSecurityCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                      <li>
                        <Checkbox
                          label={t('project.menu.high')}
                          value="high"
                          checked={securities.indexOf('high') > -1}
                          onChange={this.handleSecurityCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                      <li>
                        <Checkbox
                          label={t('project.menu.medium')}
                          value="medium"
                          checked={securities.indexOf('medium') > -1}
                          onChange={this.handleSecurityCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                      <li>
                        <Checkbox
                          label={t('project.menu.low')}
                          value="low"
                          checked={securities.indexOf('low') > -1}
                          onChange={this.handleSecurityCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                    </ul>
                  </div>
                  <div className="setting_issues_content_item">
                    <span className="label">
                      {t('project.menu.license')}
                    </span>
                    <ul className="options">
                      <li>
                        <Checkbox
                          label={t('card.menu.protective')}
                          value="protective"
                          checked={licenses.indexOf('protective') > -1}
                          onChange={this.handleLicenseCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                      <li>
                        <Checkbox
                          label={t('card.menu.permissive')}
                          value="permissive"
                          checked={licenses.indexOf('permissive') > -1}
                          onChange={this.handleLicenseCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                      <li>
                        <Checkbox
                          label={t('card.menu.others')}
                          value="others"
                          checked={licenses.indexOf('others') > -1}
                          onChange={this.handleLicenseCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                    </ul>
                  </div>
                  <div className="setting_issues_content_item">
                    <span className="label">
                      {t('card.menu.litigator')}
                    </span>
                    <ul className="options">
                      <li>
                        <Checkbox
                          label={t('contents_header.menu.mchardy')}
                          value="mchardy"
                          checked={litigators.indexOf('mchardy') > -1}
                          onChange={this.handleLitigatorCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                      <li>
                        <Checkbox
                          label={t('contents_header.menu.sfc')}
                          value="sfc"
                          checked={litigators.indexOf('sfc') > -1}
                          onChange={this.handleLitigatorCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                      <li>
                        <Checkbox
                          label={t('contents_header.menu.patent')}
                          value="patents"
                          checked={litigators.indexOf('patents') > -1}
                          onChange={this.handleLitigatorCheckChange}
                          readOnly={!isAdmin}
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              ) : null
            }
            {
              isAdmin ? (
                <div className="setting_issues_bottom" style={{ bottom: '-260px', position: 'absolute' }}>
                  {
                    isUseIssue
                    && <a className="revert" onClick={this.handleRevert} onKeyUp={this.handleRevert}>{t('settings.button.revert')}</a>
                  }
                  <a className="save" onClick={this.handleSaveModal} onKeyUp={this.handleSaveModal}>{t('system.button.save')}</a>
                </div>
              ) : null
            }
          </div>
        )}
        <Modal open={this.state.isOpenModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a className="left_button" onClick={this.closeModal} onKeyUp={this.closeModal}>
                    {t('modal.button.cancel')}
                  </a>
                  <a className="right_button" onClick={this.setIssueSetting} onKeyUp={this.setIssueSetting}>
                    {t('modal.button.save')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal open={this.state.isOpenAlert} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <CreateJiraIssueSettingModal
          isOpenMCI={isOpenMCI}
          closeModal={this.closeModal}
          completeCallback={this.handleJiraIssueCallback}
          translate={t}
          hasJira={hasJira}
        />
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(IssueSetting))));
